export default __webpack_public_path__ + "static/media/lds-logo_it.224fe5b3d997e949.svg";